import { client } from './utils';
import { getResponseData, uri } from './utils/helpers';

export const getClientDbLlmSettings = (clientDbId) =>
    client.get(uri`/account/client-db-llm-settings/${clientDbId}`).then(getResponseData);

export const saveClientDbLlmSettings = (clientDbId, settings) =>
    client.put(uri`/account/client-db-llm-settings/${clientDbId}`, settings).then(getResponseData);
